import { useShallow } from 'zustand/shallow';

import { OpenCallState, store } from './store';

export const useOpenCalls = () => {
  const {
    data,
    loading,
    error,
    fetchOpenCalls,
    reset,
    totalCount,
    page,
    limit,
  } = store<OpenCallState>(
    useShallow((state) => ({
      data: state.data,
      loading: state.loading,
      error: state.error,
      fetchOpenCalls: state.fetchOpenCalls,
      reset: state.reset,
      totalCount: state.totalCount,
      page: state.page,
      limit: state.limit,
    })),
  );

  return {
    openCalls: data,
    loading,
    error,
    fetchOpenCalls,
    reset,
    totalCount,
    page,
    limit,
  };
};
